<div class="wrapper">
  <div class="error-entry" *ngFor="let errorDetails of deviceErrors">
    <div class="error-description">
      <h3>{{ '+SERVICE_APP.NEW_REQUEST.ERROR_CODE.FAULT_CODE' | translate }}</h3>
      <div>{{ errorDetails.faultCode }}</div>
    </div>
    <div class="error-description">
      <h3>{{ '+SERVICE_APP.NEW_REQUEST.ERROR_CODE.BEHAVIOR_OF_THE_SYSTEM' | translate }}</h3>
      <div [innerHtml]="errorDetails.systemCharacteristics"></div>
    </div>
    <ng-container *ngFor="let cause of errorDetails?.causes">
      <div class="error-description">
        <h3>{{ '+SERVICE_APP.NEW_REQUEST.ERROR_CODE.CAUSE_OF_FAILURE' | translate }}</h3>
        <div [innerHtml]="cause.cause"></div>
      </div>
      <div class="error-description">
        <h3>{{ '+SERVICE_APP.NEW_REQUEST.ERROR_CODE.MEASURE' | translate }}</h3>
        <div [innerHtml]="cause.measure"></div>
      </div>
    </ng-container>
  </div>

  <app-banner type="info" *ngIf="!deviceErrors || deviceErrors?.length === 0">
    {{ '+SERVICE_TOOL.NO_DETAILED_ERROR_INFORMATION' | translate }}
  </app-banner>
</div>
